import * as t from 'io-ts'

export const Address = t.type({
  postalAddress: t.string,
  postalCode: t.string,
  postOffice: t.string
})

export type Address = t.TypeOf<typeof Address>

export const Role = t.union([t.literal('CHAIRMAN'), t.literal('SIGNER')])

export type Role = t.TypeOf<typeof Role>

export const Representative = t.type({
  id: t.string,
  role: Role,
  firstName: t.string,
  lastName: t.string,
  ssnHash: t.string,
  phone: t.string,
  email: t.string,
  isSigner: t.boolean,
  isEmailRecipient: t.boolean
})

export type Representative = t.TypeOf<typeof Representative>

export const Area = t.union([
  t.literal('SUUR_ESPOONLAHTI'),
  t.literal('SUUR_LEPPAVAARA'),
  t.literal('SUUR_MATINKYLA'),
  t.literal('SUUR_TAPIOLA'),
  t.literal('SUUR_KAUKLAHTI'),
  t.literal('VANHA_ESPOO'),
  t.literal('POHJOIS_ESPOO'),
  t.literal('OUTSIDE_OF_ESPOO')
])

export type Area = t.TypeOf<typeof Area>

export const Attachment = t.type({
  name: t.string,
  path: t.string,
  version: t.union([t.string, t.null])
})

export type Attachment = t.TypeOf<typeof Attachment>

export const InitialOrg = t.type({
  id: t.string,
  representatives: t.array(Representative),
  modifiedAt: t.string
})

export const OrgType = t.union([
  t.literal('ASSOCIATION'),
  t.literal('COMPANY'),
  t.literal('FOUNDATION')
])
export type OrgType = t.TypeOf<typeof OrgType>

export const Org = t.type({
  id: t.string,
  type: OrgType,
  name: t.string,
  registrationId: t.string,
  registrationDate: t.string,
  address: Address,
  domicile: t.string,
  email: t.string,
  wwwAddress: t.union([t.string, t.null]),
  bankAccount: t.string,
  areas: t.array(Area),
  requiredSignersAmount: t.number,
  representatives: t.array(Representative),
  attachments: t.array(Attachment),
  modifiedAt: t.string,
  modifiedBy: t.string
})

export type Org = t.TypeOf<typeof Org>
